import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "@/lib/api";
import { useSession } from "@/context/Session";
import { presetFor } from "@/lib/presets";
import { SourceImage } from "@/components/SourceImage";
import { t } from "@/i18n";
import { Tt } from "@/components/Tt";

export function SpecialsBoard() {
  const api = useApi();
  const Icon = presetFor(useSession().me.org?.preset).specialIcon;
  const [items, setItems] = useState<any[]>([]);
  useEffect(() => {
    const load = () => api.get("/specials").then((r) => setItems(r.data)).catch(() => {});
    load();
    window.addEventListener("smboi:review-changed", load);
    return () => window.removeEventListener("smboi:review-changed", load);
  }, [api]);
  if (!items.length) return null;
  return (
    <div className="flex items-center gap-2 overflow-x-auto px-2 py-1 rounded-full bg-[var(--bg-primary)] rise" data-testid="specials-board">
      <span className="mono-label shrink-0">{t("This week's specials")}</span>
      {items.map((s) => (
        <Link key={s.id} to={`/sops/${s.id}`} className="shrink-0 flex items-center gap-2 rounded-full bg-[var(--bg-surface)] border border-[var(--border-color)] pl-1 pr-3 py-1 hover:-translate-y-0.5 transition-transform" data-testid={`special-card-${s.id}`}>
          {s.cover_source_id
            ? <SourceImage sourceId={s.cover_source_id} className="w-9 h-9 rounded-full" testid={`special-cover-${s.id}`} />
            : <span className="w-9 h-9 rounded-full grid place-items-center bg-[var(--accent-subtle)] text-[var(--accent-primary)]"><Icon size={16} /></span>}
          <span className="text-sm font-semibold max-w-[10rem] truncate"><Tt text={s.title} /></span>
        </Link>
      ))}
    </div>
  );
}
